'use client';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faRotateRight } from '@icons/classic/regular';

import { Button } from './Button';
import { Tooltip, TooltipContent, TooltipTrigger } from './Tooltip';

export interface RefreshButtonProps {
  /** Whether a refresh is in flight — spins the icon and disables the button. */
  isFetching: boolean;
  onClick: () => void;
  /** Tooltip text shown on hover (default: "Refresh"). */
  tooltip?: string;
}

/**
 * Icon-only refresh button with a tooltip and a spin-while-fetching affordance.
 * Presentational only: the caller owns the refresh (e.g. queryClient.invalidateQueries)
 * and supplies `isFetching` (e.g. from useIsFetching) so the button can spin and disable.
 */
export function RefreshButton({ isFetching, onClick, tooltip = 'Refresh' }: RefreshButtonProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button aria-label={tooltip} disabled={isFetching} onClick={onClick} size="sm" variant="secondary">
          <FontAwesomeIcon className={`h-3.5 w-3.5 ${isFetching ? 'animate-spin' : ''}`} icon={faRotateRight} />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  );
}
